module.exports = function (value) {
  return value==='' || isNaN(value) ? value : parseFloat(value);
};
